import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

// import Custom Components
import SideBar from "../../features/sidebar/shop-filter";
import ProductListTwo from "../../features/product/list/product-list-two";
import PageHeader from "../../common/page-header";
import Breadcrumb from "../../common/breadcrumb";

function NoSideBar(props) {
  const type = "boxed";
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const query = searchParams.get("q");
  const category = searchParams.get("c");
  const ProdcutType = searchParams.get("T");

  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    handleScrollToTop();
    if (type !== "boxed" && type !== "fullwidth") {
      window.location = "/pages/404";
    }
  }, [type]);

  function hideSideBar() {
    if (
      document.querySelector("body").classList.contains("sidebar-filter-active")
    )
      document.querySelector("body").classList.remove("sidebar-filter-active");
  }

  return (
    <>
      <Helmet>
        <title>LIBER | Shop</title>
      </Helmet>

      <h1 className="d-none">
        liber React eCommerce Template - Shop No Sidebar
      </h1>

      <div className="main">
        <PageHeader
          title={
            ProdcutType
              ? ProdcutType === "featured"
                ? "CLEARENCE SALE"
                : "NEW COLLECTIONS"
              : "COLLECTIONS"
          }
          subTitle="Shop"
        />
        <Breadcrumb
          title={"Shop"}
          adClass="mb-2"
          container={type === "boxed" ? "container" : "container-fluid"}
        />

        <div className="page-content">
          <div className={type === "boxed" ? "container" : "container-fluid"}>
            <ProductListTwo
              type={type}
              query={query}
              ProdcutType={ProdcutType}
            />

            <div className="sidebar-filter-overlay" onClick={hideSideBar}></div>

            <SideBar categoryQuery={category} numbers={50} />
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(NoSideBar);
